import dayjs from 'dayjs'
import type { HeatmapPoint } from '@/types/dashboard'

/**
 * Серия дней активности по точкам heatmap — чтобы не запрашивать её отдельно.
 *
 * Повторяет правило бэкенда (StreakService в easya-api): текущая серия не
 * рвётся, если сегодня активности ещё не было — якорем допускается вчерашний
 * день.
 */
export function computeStreak(days: HeatmapPoint[]): { current: number; longest: number } {
  const active = days
    .filter((point) => point.count > 0)
    .map((point) => point.date)
    .sort((a, b) => (a < b ? 1 : -1))

  if (active.length === 0) return { current: 0, longest: 0 }

  const today = dayjs().startOf('day')
  const todayString = today.format('YYYY-MM-DD')
  const yesterdayString = today.subtract(1, 'day').format('YYYY-MM-DD')

  let current = 0
  let cursor: dayjs.Dayjs | null = null
  if (active[0] === todayString) cursor = today
  else if (active[0] === yesterdayString) cursor = today.subtract(1, 'day')

  if (cursor) {
    for (const date of active) {
      if (date !== cursor.format('YYYY-MM-DD')) break
      current++
      cursor = cursor.subtract(1, 'day')
    }
  }

  let longest = 1
  let run = 1
  for (let i = 1; i < active.length; i++) {
    const expected = dayjs(active[i - 1]).subtract(1, 'day').format('YYYY-MM-DD')
    run = active[i] === expected ? run + 1 : 1
    longest = Math.max(longest, run)
  }

  return { current, longest: Math.max(longest, current) }
}
